<template>
  <v-tabs>
    <v-tab
      :to="{
        name: 'ProgressGoalSettingBehaviourChangeGoals',
        params: {
          patientId,
        },
      }"
    >
      {{ $ucfirst($t("journeyBehaviourChangeGoals.behaviourChangeGoals")) }}
    </v-tab>
    <v-tab
      :to="{
        name: 'ProgressGoalSettingOutcomeGoals',
        params: {
          patientId,
        },
      }"
    >
      {{ $ucfirst($t("journeyOutcomeGoals.outcomeGoals")) }}
    </v-tab>
  </v-tabs>
</template>

<script>
import { mapGetters } from "vuex";

/**
 * Component JourneyGoalSettingTabs.vue
 *
 * @module JourneyGoalSettingTabs
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.5] app/src/APP_DASHBOARD/templates/components/Parts/JourneyGoalSettingTabs.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "JourneyGoalSettingTabs",
  computed: {
    ...mapGetters({
      patientId: "patientSummary/id",
    }),
  },
};
</script>

<style lang="scss">
</style>